import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';
import { createCustomPropType, isUuid, isNumeric } from '../../js/app/react/validators';

class MobileEducationChartView extends Component {
  componentDidMount() {
    const { hasChartData, dataIsOutdated, isPrint } = this.props;

    if ((!hasChartData || dataIsOutdated) && !isPrint) {
      const {
        clientId, fpId, getChartData, goalId, isPdf,
      } = this.props;
      getChartData(fpId, clientId, isPdf, goalId);
    }
  }

  render() {
    const { chartData, hasLoaded } = this.props;

    return (
      <section>
        <div
          className="
                    NewFinancialPlan_ProgressChart
                    NewFinancialPlan_EducationProgressChart"
        >
          <div
            className="
                        chart
                        NewFinancialPlan_EducationProgressChart_BarChart"
          >
            {!hasLoaded && <LoadingChart />}
            {hasLoaded && (
              <ReactHighcharts
                autoResize
                className="education-chart-container"
                container="EducationChartContainer"
                options={chartData}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
}

MobileEducationChartView.defaultProps = {
  isPdf: false,
  isPrint: false,
};

MobileEducationChartView.propTypes = {
  chartData: PropTypes.shape({}).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  dataIsOutdated: PropTypes.bool.isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  getChartData: PropTypes.func.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  hasChartData: PropTypes.bool.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  isPdf: PropTypes.bool,
  isPrint: PropTypes.bool,
};

export default MobileEducationChartView;
